import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";
import "../../styles/ContextMenu.css";
import { FaIcon } from "../../shared/ui";
import { faTrash,faBan } from "@fortawesome/free-solid-svg-icons";

const ContextMenu = ({ onDelete, onBlockUser, onClose, position }) => {
  const menuRef = useRef();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose]);

  return (
    <div
      ref={menuRef}
      className="context-menu"
      style={{
        top: position.top - 5,
        left: position.left,
      }}
    >
      <div className="context-menu-item delete" onClick={onDelete}>
        <FaIcon icon={faTrash} className="p-1" />
        <span>Delete Conversation</span>
      </div>
      <div className="context-menu-item block" onClick={onBlockUser}>
        <FaIcon icon={faBan} className="p-1" />
        <span>Block User</span>
      </div>
    </div>
  );
};

ContextMenu.propTypes = {
  onDelete: PropTypes.func.isRequired,
  onBlockUser: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  position: PropTypes.object.isRequired,
};

export default ContextMenu;
